import { JSX, useEffect, useRef, useState } from "react";
import { SubscribeGlobalState } from "../../../common/hooks/global-state";
import { Header, NavMobileMenu } from "./header";
import { BackgroundImage } from "../ui/file-contents";
import { Footer } from "./footer";

export const PageContainer: React.FC<{
    staticBg?: boolean
    containerClassName?: string
    footerClassName?: string
    child?: JSX.Element,
    headerImgPath?: string
    checkAuth?: boolean
    checkAdmin?: boolean
}> = ({ child, headerImgPath, containerClassName, checkAuth, checkAdmin, staticBg, footerClassName }) => {
    const user = SubscribeGlobalState("authorizedUser");

    const mobileNavigationsRef = useRef<HTMLDivElement>(null)
    const [showMobileNavigations, setShowMobileNavigations] = useState(false);

    useEffect(() => {
        if (staticBg)
            document.body.classList.add('bg-dark-xl');

        return () => {
            document.body.classList.remove('bg-dark-xl');
        };
    }, []);

    if (checkAuth && !user) {
        window.location.pathname = '/';
    }

    if ((checkAdmin && !user) || (checkAdmin && user && user.role != 'Admin')) {
        window.location.pathname = '/';
    }

    return <div className={`relative w-full overflow-x-hidden min-h-screen`} >
        {
            headerImgPath && <BackgroundImage
                src={headerImgPath}
                fromCdn={true}
            />}
        <Header />
        <main className={`mt-[50px] lg:mt-[126px] w-full mx-auto ${containerClassName ?? ''}`}>
            {child}
        </main>
        <Footer className={footerClassName} />
    </div>
}